module.exports = "/assets/hospital_postcode_selected-58df28a3eaa7ce4be9d9b0b3ce7aca59.svg";